<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-n2">Conferências</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataConferencias"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-spacer />
          <v-col cols="4" class="mr-14 my-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/conferencia/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Conferências: {{ qtdConferencias }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import conferenciaStore from '../_store'

export default {
  components: { ListPagination },
  mixins: [pagesHomeMixins],
  data: () => ({
    dataConferencias: [],
    headers: [
      {
        text: 'Conferência',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Editar',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapGetters('conferenciaHomeModulePABXStore', ['getTodasConferencias']),

    numberOfPages() {
      return Math.ceil(this.dataConferencias.length / this.itemsPerPage)
    },
    qtdConferencias() {
      return this.dataConferencias.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'conferenciaHomeModulePABXStore', conferenciaStore)

    await this.listarConferencias()
    this.dataConferencias = [...this.getTodasConferencias]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('conferenciaHomeModulePABXStore', ['listarConferencias']),

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`conferencia/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`conferencia/atualizar/${item.item._id}`)
      }
    },
    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`conferencia/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`conferencia/atualizar/${item._id}`)
      }
    },
  },
}
</script>
